var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUpArrowGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "5 5 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_219",
    "data-name": "Rect\\xE1ngulo 219",
    width: 24,
    height: 24,
    fill: "#B7B7B7",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rango_fecha",
    transform: "translate(0 24) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_30",
    "data-name": "Enmascarar grupo 30",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_arrow-right_",
    "data-name": "FontAwsome (arrow-right)",
    d: "M4.543,38.348l.529-.529a.57.57,0,0,1,.808,0l4.636,4.633a.57.57,0,0,1,0,.808L5.88,47.9a.57.57,0,0,1-.808,0l-.529-.529a.573.573,0,0,1,.01-.818l2.873-2.738H.572A.571.571,0,0,1,0,43.238v-.763A.571.571,0,0,1,.572,41.9H7.426L4.552,39.165A.569.569,0,0,1,4.543,38.348Z",
    transform: "translate(6.658 -30.591)",
    fill: "#B7B7B7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpArrowGray);
export default __webpack_public_path__ + "static/media/icon_up_arrow_gray.90ae4bbf1c55935abe10d5e88f790593.svg";
export { ForwardRef as ReactComponent };